const config = {
  testingAPI: "https://posttagtesting.com",
  servicesAPI: "https://posttagservices.com",
  toolsAPI: "https://www.posttagtools.com",
};

export default config;
